<template>
  <div id="hotelList">
    <!-- 文件选择 -->
    <Explorer
      :visible="explorerDialogVisible"
      :fileData="fileData"
      :fileSum="fileSum"
      :select="explorerSelect"
      :type="iconType"
      @query="resourceGet"
      @close="explorerDialogVisible = false"
      @confirm="confirm"
      @selected="selected"
    ></Explorer>
    <!-- 弹窗 -->
    <el-dialog
      v-model="dialogVisible"
      :title="`${form.id ? `编辑门店 - ${form.id}` : '添加门店'}`"
      :width="$store.state.screenWidth > 1200 ? '600px' : '98%'"
      align-center
      @closed="dialogClosed"
      :close-on-click-modal="false"
    >
      <el-form :model="form" ref="formRef" :rules="rules">
        <el-form-item label="门店名称" label-width="120px" prop="name">
          <el-input
            v-model="form.name"
            placeholder="请输入门店名称"
            clearable
          />
        </el-form-item>
        <el-form-item label="门店类型" label-width="120px" prop="tid">
          <el-select v-model="form.tid" placeholder="请选择门店类型">
            <el-option
              v-for="item in hotelTypeData2"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="洗衣机配置类型" label-width="120px" prop="tid">
          <el-select
            v-model="form.wash_mode"
            placeholder="请选择洗衣机配置类型"
          >
            <el-option
              v-for="item in wash_modeData"
              :key="item.id"
              :label="item.name + (item.description || '')"
              :value="item.id"
            />
          </el-select>
        </el-form-item>

        <el-form-item
          label="门店logo"
          label-width="120px"
          style="display: flex; align-items: center"
          prop="logo"
        >
          <div class="avatar-uploader2">
            <template v-if="form.logo">
              <div class="avatar">
                <img :src="$dataConver.urlFilter(form.logo)" />
                <el-icon class="del" @click.stop="form.logo = ''"
                  ><CircleCloseFilled
                /></el-icon>
              </div>
            </template>

            <el-icon v-else @click="iconEditor(2, 'radio')"><Plus /></el-icon>
          </div>
        </el-form-item>
        <el-form-item
          label="门店图片"
          label-width="120px"
          style="display: flex; align-items: center"
        >
          <div class="avatar-uploader2">
            <template v-if="form.images.length != 0">
              <div
                v-for="(item, index) in form.images"
                :key="index"
                class="avatar"
              >
                <img :src="$dataConver.urlFilter(item)" />
                <el-icon class="del" @click.stop="form.images.splice(index, 1)"
                  ><CircleCloseFilled
                /></el-icon>
              </div>
            </template>

            <el-icon @click="iconEditor(201, 'checked')"><Plus /></el-icon>
          </div>
        </el-form-item>
        <el-form-item label="省市区" label-width="120px">
          <el-cascader
            v-model="districtValue"
            :options="district"
            style="width: 100%"
          />
        </el-form-item>
        <el-form-item label="门店详细地址" label-width="120px" prop="address">
          <el-input
            v-model="form.address"
            placeholder="请输入门店详细地址"
            :autosize="{ minRows: 2, maxRows: 4 }"
            type="textarea"
          />
        </el-form-item>
        <el-form-item label="门店联系人" label-width="120px" prop="username">
          <el-input
            v-model="form.username"
            placeholder="请输入门店联系人"
            clearable
          />
        </el-form-item>
        <el-form-item label="门店联系电话" label-width="120px" prop="tel">
          <el-input
            v-model="form.tel"
            placeholder="请输入门店联系电话"
            clearable
          />
        </el-form-item>
        <el-form-item
          label="门店内部代码"
          label-width="120px"
          prop="extra_code"
        >
          <el-input
            v-model="form.extra_code"
            placeholder="请输入门店内部代码"
            clearable
          />
        </el-form-item>
        <el-form-item label="门店星级" label-width="120px" prop="hotel_star">
          <el-rate v-model="form.hotel_star" />
        </el-form-item>
        <el-form-item label="状态" label-width="120px" prop="state">
          <el-switch
            v-model="form.state"
            :active-value="1"
            :inactive-value="0"
          />
        </el-form-item>
        <el-form-item label="备注" show-overflow-tooltip label-width="120px">
          <el-input
            v-model="form.remark"
            :autosize="{ minRows: 2, maxRows: 4 }"
            type="textarea"
            placeholder="请输入备注"
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="addhotelList(formRef)"
            >确定</el-button
          >
        </span>
      </template>
    </el-dialog>
    <!-- PMS配置弹窗 -->
    <el-dialog
      v-model="dialogVisible2"
      title="PMS配置"
      :width="$store.state.screenWidth > 1200 ? '600px' : '98%'"
      align-center
      @closed="dialogClosed2"
      :close-on-click-modal="false"
    >
      <el-form :model="form2" ref="formRef2" :rules="rules2">
        <el-form-item label="PMS类型" label-width="120px" prop="type">
          <el-select v-model="form2.type" placeholder="请选择门店类型">
            <el-option
              v-for="item in pmsTypeData"
              :key="item.type"
              :label="item.name"
              :value="item.type"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          v-for="item in formMap[form2.type]"
          :key="item.itemKey"
          :label="item.itemName"
          label-width="120px"
        >
          <el-input
            v-model="item.itemValue"
            :placeholder="`请输入${item.itemName}`"
            clearable
          />
        </el-form-item>
        <el-form-item label="状态" label-width="120px" prop="state">
          <el-switch
            v-model="form2.state"
            :active-value="1"
            :inactive-value="0"
          />
        </el-form-item>
        <el-form-item label="备注" show-overflow-tooltip label-width="120px">
          <el-input
            v-model="form2.remark"
            :autosize="{ minRows: 2, maxRows: 4 }"
            type="textarea"
            placeholder="请输入备注"
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogVisible2 = false">取消</el-button>
          <el-button type="primary" @click="pmsSettingSet(formRef2)"
            >确定</el-button
          >
        </span>
      </template>
    </el-dialog>
    <!-- 头部 -->
    <div class="head">
      <div class="head_left">
        <el-button
          v-grantShow="$store.state.SysGrant.AddHotel"
          type="primary"
          icon="Plus"
          @click="dialogVisible = true"
          >添加门店</el-button
        >
        <el-button
          v-grantShow="$store.state.SysGrant.DelHotel"
          type="danger"
          icon="Delete"
          @click="hotelListDel(checkedData, 'all')"
          >删除门店</el-button
        >
        <el-button
          type="warning"
          icon="Switch"
          @click="handOver(checkedData, 'all')"
          >移交门店</el-button
        >
      </div>
      <div class="head_right">
        <el-cascader
          v-model="districtSearchValue"
          :options="district"
          placeholder="请选择省市区"
          clearable
          :props="{
            checkStrictly: true,
          }"
        />
        <el-input
          v-model="hotelList_req.value"
          placeholder="请输入关键词"
          class="input-with-select"
          :clearable="true"
        >
          <template #append>
            <el-button icon="Search" @click="hotelListGet" />
          </template>
          <template #prepend>
            <el-select
              v-model="selectId"
              placeholder="Select"
              style="width: 100px"
            >
              <el-option
                v-for="(item, index) in selectData"
                :key="index"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </template>
        </el-input>
      </div>
    </div>
    <!-- 表格 -->
    <el-table
      ref="multipleTable"
      :data="hotelListData"
      tooltip-effect="dark"
      style="width: 100%"
      :border="false"
      :header-cell-style="{ backgroundColor: '#F4F7FB' }"
      :header-row-style="{
        backgroundColor: '#F4F7FB',
        color: '#1E2026',
      }"
      @selection-change="
        (value) => {
          checkedData = value.map((item) => item.id);
        }
      "
    >
      <el-table-column
        type="selection"
        :width="$store.state.screenWidth > 1200 ? 55 : 30"
      />
      <el-table-column prop="name" label="门店信息" min-width="250">
        <template #default="scope">
          <div class="info">
            <el-image
              v-if="scope.row.logo"
              class="logo"
              :src="$dataConver.urlFilter(scope.row.logo)"
              fit="cover"
            />
            <div class="right">
              <div class="name">
                <el-link type="primary" @click="hotelListEditor(scope.row)">{{
                  scope.row.name
                }}</el-link>
              </div>
              <div class="code" @click="onCopy(scope.row.code)">
                <el-text type="info">门店代码：{{ scope.row.code }}</el-text>
                <el-icon><CopyDocument /></el-icon>
              </div>
              <div v-if="scope.row.hotel_star">
                <el-rate v-model="scope.row.hotel_star" disabled size="small" />
              </div>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="wash_mode" class-name="screen" min-width="150">
        <template #header>
          <span>洗衣机配置类型</span>
        </template>
        <template #default="scope">
          <el-tag
            disable-transitions
            :type="
              wash_modeData[scope.row.wash_mode]
                ? wash_modeData[scope.row.wash_mode].type
                : '--'
            "
            >{{
              wash_modeData[scope.row.wash_mode]
                ? wash_modeData[scope.row.wash_mode].name
                : "--"
            }}</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column prop="name" class-name="screen" min-width="150">
        <template #header>
          <span :style="hotelList_req.tid !== '' ? 'color:#059669;' : ''"
            >门店类型</span
          >
          <el-dropdown
            trigger="click"
            popper-class="dropdown"
            @command="handleCommand"
            v-if="
              !$dataConver.checkGrants(
                $store.state.userInfo.grants,
                $store.state.SysGrant.GetAllHotel
              )
            "
          >
            <el-icon><ArrowDown /></el-icon>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item
                  command=""
                  :class="hotelList_req.tid === '' ? 'index' : ''"
                  >全部</el-dropdown-item
                >
                <el-dropdown-item
                  :command="item.id"
                  :class="hotelList_req.tid === item.id ? 'index' : ''"
                  v-for="item in hotelTypeData"
                  :key="item.id"
                  >{{ item.name }}</el-dropdown-item
                >
              </el-dropdown-menu>
            </template>
          </el-dropdown></template
        >
        <template #default="scope">
          <el-tag disable-transitions type="primary">{{
            scope.row.hotelType.name || "--"
          }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="门店所属人" min-width="120">
        <template #default="scope">
          <template v-if="scope.row.userInfo">
            <div>{{ scope.row.userInfo.realname }}</div>
          </template>
          <div v-else>--</div>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="联系人" min-width="120">
        <template #default="scope">
          <template v-if="scope.row.username">
            <div>{{ scope.row.username }}</div>
            <div>
              <el-link :underline="false" @click="call(scope.row.tel)">{{
                scope.row.tel
              }}</el-link>
            </div>
          </template>
          <div v-else>--</div>
        </template>
      </el-table-column>
      <el-table-column label="省市区" min-width="150" show-overflow-tooltip>
        <template #default="scope">
          {{
            $fullCitys.formatData(
              $fullCitys.getAuto(
                scope.row.prov,
                scope.row.city,
                scope.row.area,
                0
              )
            ).prov || ""
          }}{{
            $fullCitys.formatData(
              $fullCitys.getAuto(
                scope.row.prov,
                scope.row.city,
                scope.row.area,
                0
              )
            ).city || ""
          }}{{
            $fullCitys.formatData(
              $fullCitys.getAuto(
                scope.row.prov,
                scope.row.city,
                scope.row.area,
                0
              )
            ).area || ""
          }}
        </template>
      </el-table-column>
      <!-- <el-table-column label="详细地址" min-width="150" show-overflow-tooltip>
        <template #default="scope">
          {{ scope.row.address || "--" }}
        </template>
      </el-table-column> -->
      <el-table-column label="备注" min-width="150" show-overflow-tooltip>
        <template #default="scope">
          {{ scope.row.remark || "--" }}
        </template>
      </el-table-column>
      <!-- <el-table-column label="添加时间" min-width="160">
        <template #default="scope">
          <template v-if="scope.row.addtime">
            {{
              $moment(scope.row.addtime * 1000).format("yyyy-MM-DD HH:mm:ss")
            }}
          </template>
          <template v-else> -- </template>
        </template>
      </el-table-column> -->
      <el-table-column label="状态" min-width="80">
        <template #default="scope">
          <el-switch
            v-model="scope.row.state"
            :active-value="1"
            :inactive-value="0"
            @change="stateChange(scope.row)"
            :disabled="
              !$dataConver.checkGrants(
                $store.state.userInfo.grants,
                $store.state.SysGrant.AddHotel
              )
            "
          />
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        width="90"
        align="center"
        :fixed="$store.state.screenWidth > 1200 ? 'right' : 'right' || false"
      >
        <template #default="scope">
          <el-button link type="primary" @click="settingOpen(scope.row)"
            >厂商配置</el-button
          >
          <el-divider
            direction="horizontal"
            style="--el-border-style: solid; margin: 8px 0px"
          ></el-divider>
          <el-button link type="primary" @click="deviceOpen(scope.row)"
            >设备管理</el-button
          >
          <el-divider
            direction="horizontal"
            style="--el-border-style: solid; margin: 8px 0px"
            v-grantShow="$store.state.SysGrant.SetPmsSettings"
            v-if="pmsState"
          ></el-divider>
          <el-button
            v-grantShow="$store.state.SysGrant.SetPmsSettings"
            v-if="pmsState"
            link
            type="primary"
            @click="pmsSettingOpen(scope.row)"
            >PMS配置</el-button
          >
          <el-divider
            direction="horizontal"
            style="--el-border-style: solid; margin: 8px 0px"
            v-grantShow="$store.state.SysGrant.AddHotel"
          ></el-divider>
          <el-button
            link
            type="primary"
            v-grantShow="$store.state.SysGrant.AddHotel"
            @click="hotelListEditor(scope.row)"
            >编辑</el-button
          >
          <!-- <el-divider
            direction="horizontal"
            v-if="
              $dataConver.checkGrants(
                $store.state.userInfo.grants,
                $store.state.SysGrant.SetAllHotel
              ) || scope.row.uid == $store.state.userInfo.uid
            "
          ></el-divider>
          <el-button
            v-if="
              $dataConver.checkGrants(
                $store.state.userInfo.grants,
                $store.state.SysGrant.SetAllHotel
              ) || scope.row.uid == $store.state.userInfo.uid
            "
            link
            type="primary"
            @click="handOver(scope.row.id)"
            >移交</el-button
          > -->
          <el-divider
            direction="horizontal"
            style="--el-border-style: solid; margin: 8px 0px"
            v-grantShow="$store.state.SysGrant.DelHotel"
          ></el-divider>
          <el-button
            v-grantShow="$store.state.SysGrant.DelHotel"
            link
            type="primary"
            @click="hotelListDel(scope.row.id)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 页码 -->
    <el-pagination
      background
      :pager-count="$store.state.screenWidth > 1200 ? 7 : 5"
      :page-sizes="[10, 20, 100, 200, 500, 1000]"
      layout="prev,pager,next,sizes,slot"
      v-model:current-page="hotelList_req.page"
      v-model:page-size="hotelList_req.page_max"
      :total="tableCount"
    >
      <div class="statistical">
        每页<b style="color: #ff0000">{{ hotelList_req.page_max }}</b
        >条/共<b style="color: #059669">{{ tableCount }}</b> 条数据
      </div>
    </el-pagination>
  </div>
</template>

<script setup>
import {
  reactive,
  ref,
  getCurrentInstance,
  onMounted,
  watch,
  nextTick,
  onActivated,
  inject,
  computed,
} from "vue";
import { useStore } from "vuex";
import { ElMessage, ElMessageBox } from "element-plus";
import Province from "@/utils/full-citys.js";
//引入组件
import Explorer from "@/components/explorer.vue";
import config from "@/utils/config";
//获取公共方法
let { proxy } = getCurrentInstance();
//全局数据
let vuex = useStore();
//打开抽屉
let opendrawer = inject("opendrawer");
//pms状态
let pmsState = config.pmsState||false;
//门店请求参数
let hotelList_req = reactive({
  tid: "",
  value: "",
  page: 1,
  page_max: 10,
});
//表单对象
let formRef = ref(null);
//门店表单数据
let form = reactive({
  name: "",
  tid: "",
  extra_code: "",
  country: 0,
  prov: 0,
  city: 0,
  area: 0,
  wash_mode: 0,
  address: "",
  username: "",
  tel: "",
  logo: "",
  images: [],
  hotel_star: 0,
  remark: "",
  state: 1,
});
//校验规则
let rules = reactive({
  name: [{ required: true, message: "门店名称不能为空", trigger: "blur" }],
  tid: [{ required: true, message: "请选择门店类型", trigger: "blur" }],
});
//搜索省市区
let districtSearchValue = ref([]);
//地区数据
let district = ref([]);
//地区值
let districtValue = ref([]);
//文件选择弹窗显示状态
let explorerDialogVisible = ref(false);
//文件类型选中值
let explorerSelect = ref(2);
//文件数据
let fileData = ref([]);
//文件总数
let fileSum = ref(0);
//文件选择类型
let iconType = ref("radio");
//搜索门店
let selectData = {
  1: {
    label: "门店名称",
    value: 1,
    key: "name",
  },
  2: {
    label: "门店代码",
    value: 2,
    key: "code",
  },
  3: {
    label: "联系人",
    value: 3,
    key: "username",
  },
  4: {
    label: "联系电话",
    value: 4,
    key: "tel",
  },
  5: {
    label: "	备注",
    value: 5,
    key: "remark",
  },
};
//多选数据
let checkedData = ref([]);
//门店类型数据
let hotelTypeData = ref([]);
//当前门店类型
let hotelType = ref(null);
//搜索id
let selectId = ref(1);
//门店数据
let hotelListData = ref([]);
//门店总数
let tableCount = ref(0);
//编辑/添加门店弹窗状态
let dialogVisible = ref(false);
//洗衣机配置类型
let wash_modeData = ref([
  {
    id: 0,
    name: "默认",
    type: "success",
  },
  {
    id: 1,
    name: "门店配置",
    description: "（每个门店单独配置）",
    type: "warning",
  },
  {
    id: 2,
    name: "个人配置",
    description: "（使用门店所属账号统一配置）",
    type: "primary",
  },
  {
    id: 3,
    name: "全局配置",
    description: "（使用全局统一配置）",
    type: "info",
  },
]);
//pms配置弹窗状态
let dialogVisible2 = ref(false);
//表单对象
let formRef2 = ref(null);
//门店表单数据
let form2 = reactive({
  type: "",
  settings: {},
  remark: "",
  state: 1,
});
//校验规则
let rules2 = reactive({
  name: [{ required: true, message: "门店名称不能为空", trigger: "blur" }],
  tid: [{ required: true, message: "请选择门店类型", trigger: "blur" }],
});
//pms类型数据
let pmsTypeData = ref([]);
//form表单字典
let formMap = reactive({
  1: [
    {
      itemKey: "hotelNum",
      itemType: "input",
      itemName: "PMS门店编号",
      itemValue: "",
    },
  ],
});
//监听请求参数变化事件
watch(
  [
    () => hotelList_req.value,
    () => hotelList_req.page_max,
    () => hotelList_req.tid,
    () => districtSearchValue.value,
    selectId,
  ],
  async (newValue, oldValue) => {
    if (hotelList_req.page == 1) {
      hotelListGet();
    } else {
      hotelList_req.page = 1;
    }
  }
);
watch([() => hotelList_req.page], async (newValue, oldValue) => {
  hotelListGet();
});
//监听省市区变化
watch([() => districtValue.value], async (newValue, oldValue) => {
  let indexArr = newValue[0];
  if (indexArr.length > 0) {
    form.prov = district.value[indexArr[0]].value;
    form.city = district.value[indexArr[0]].children[indexArr[1]].value;
    form.area =
      district.value[indexArr[0]].children[indexArr[1]].children[
        indexArr[2]
      ].value;
  }
});
//门店类型过滤
let hotelTypeData2 = computed(() => {
  if (!hotelType.value) return hotelTypeData.value;
  let arr = [hotelType.value, ...hotelTypeData.value];
  return arr.reduce((data, item) => {
    const exists = data.some((item2) => item2.id === item.id);
    if (!exists) {
      data.push(item);
    }
    return data;
  }, []);
});
//页面渲染事件
onMounted(() => {
  hotelListGet();
  getRegionData();
});
//页面重新渲染事件
onActivated(() => {
  hotelTypeGet();
});
// 加载省市区数据
const getRegionData = () => {
  const arr = [];
  const provinces = Province.getProvs();
  for (let prov of provinces) {
    const item = { label: prov.name, value: prov.id };
    const cities = Province.getCitys(prov.id);
    item.children = [];
    for (let city of cities) {
      const cityItem = { label: city.name, value: city.id };
      const areas = Province.getAreas(prov.id, city.id);
      cityItem.children = [];
      for (let area of areas) {
        const areaItem = { label: area.name, value: area.id };
        cityItem.children.push(areaItem);
      }
      if (!cityItem.children.length)
        Reflect.deleteProperty(cityItem, "children");
      item.children.push(cityItem);
    }
    arr.push(item);
  }
  district.value = arr;
};
// 编辑时初始化省市区
const setDefaultRegion = () => {
  const ruleFormData = ruleForm.value,
    values = [];
  if (ruleFormData.prov !== undefined) values.push(ruleFormData.prov);
  if (ruleFormData.prov !== undefined && ruleFormData.city !== undefined)
    values.push(ruleFormData.city);
  if (
    ruleFormData.prov !== undefined &&
    ruleFormData.city !== undefined &&
    ruleFormData.area !== undefined
  )
    values.push(ruleFormData.area);
  ruleFormData.regionValues = values;
  ruleForm.value = ruleFormData;
  regionValues.value = values;
};
//门店获取
function hotelListGet() {
  let req = {
    tid: hotelList_req.tid || undefined,
    page: hotelList_req.page,
    page_max: hotelList_req.page_max,
  };
  req[selectData[selectId.value].key] = hotelList_req.value;
  if (districtSearchValue.value && districtSearchValue.value.length > 0) {
    req.prov = district.value[districtSearchValue.value[0]].value;
  }
  if (districtSearchValue.value && districtSearchValue.value.length > 1) {
    req.city =
      district.value[districtSearchValue.value[0]].children[
        districtSearchValue.value[1]
      ].value;
  }
  if (districtSearchValue.value && districtSearchValue.value.length > 2) {
    req.area =
      district.value[districtSearchValue.value[0]].children[
        districtSearchValue.value[1]
      ].children[districtSearchValue.value[2]].value;
  }
  proxy.$http
    .get("webapi/hotel_mgr?item=list", {
      params: {
        ...req,
      },
    })
    .then(({ data: res }) => {
      if (res.code == 0) {
        tableCount.value = res.data.count;
        res.data.list.forEach((item) => {
          item.userInfo =
            res.data.users.find((item2) => item2.id == item.uid) || {};
          item.hotelType =
            res.data.types.find((item2) => item2.id == item.tid) || {};
        });
        hotelListData.value = res.data.list;
      }
    })
    .catch((err) => {
      console.log("请求失败");
    });
}
//添加门店
function addhotelList(formEl) {
  if (!formEl) return apiSend();
  formEl.validate((valid) => {
    if (valid) {
      apiSend();
    }
  });
}
//请求发送
function apiSend() {
  let grants = proxy.$dataConver.checkGrants(
    vuex.state.userInfo.grants,
    vuex.state.SysGrant.GetAllHotel
  );
  proxy.$http
    .post(`webapi/hotel_mgr?item=${form.id ? "set" : "add"}`, {
      ...form,
    })
    .then(({ data: res }) => {
      if (res.code == 0) {
        ElMessage({
          message: `${form.id ? "编辑" : "添加"}成功！`,
          type: "success",
        });
        dialogVisible.value = false;
        hotelListGet();
      } else {
        ElMessage({
          message: `${form.id ? "编辑" : "添加"}失败！`,
          type: "error",
        });
      }
    })
    .catch((err) => {
      console.log("请求失败");
    });
}
//编辑门店
function hotelListEditor(obj, show = true) {
  form.id = obj.id;
  form.name = obj.name;
  form.remark = obj.remark;
  form.state = obj.state;
  form.tid = obj.tid;
  form.extra_code = obj.extra_code;
  form.country = obj.country;
  form.prov = obj.prov;
  form.city = obj.city;
  form.area = obj.area;
  form.address = obj.address;
  form.username = obj.username;
  form.tel = obj.tel;
  form.logo = obj.logo;
  form.images = obj.images;
  form.hotel_star = obj.hotel_star;
  form.wash_mode = obj.wash_mode;
  let provIndex = 0,
    cityIndex = 0,
    areaIndex = 0;
  districtValue.value = [];
  provIndex = district.value.findIndex((item) => item.value == form.prov);
  if (provIndex != -1) {
    districtValue.value[0] = provIndex;
    cityIndex = district.value[provIndex].children.findIndex(
      (item) => item.value == form.city
    );
  }
  if (provIndex != -1 && cityIndex != -1) {
    districtValue.value[1] = cityIndex;
    areaIndex = district.value[provIndex].children[
      cityIndex
    ].children.findIndex((item) => item.value == form.area);
  }
  if (provIndex != -1 && cityIndex != -1 && areaIndex != -1) {
    districtValue.value[2] = areaIndex;
  }
  hotelType.value = obj.hotelType || undefined;
  dialogVisible.value = show;
}
//表格内状态变换事件
function stateChange(obj) {
  hotelListEditor(obj, false);
  addhotelList();
}
//删除门店
function hotelListDel(id, type) {
  if (type == "all") {
    id = id.join(",");
    if (!id)
      return ElMessage({
        message: `请选择门店`,
        type: "warning",
      });
  }
  ElMessageBox.confirm(
    `此操作将永久删除${type == "all" ? "选中" : "该"}门店, 是否继续?`,
    "提示",
    {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    }
  )
    .then(() => {
      proxy.$http
        .post(`webapi/hotel_mgr?item=del`, { id })
        .then(({ data: res }) => {
          if (res.code == 0) {
            ElMessage({
              message: `删除成功！`,
              type: "success",
            });
            dialogVisible.value = false;
            hotelListGet();
          } else {
            ElMessage({
              message: `删除失败！`,
              type: "error",
            });
          }
        })
        .catch((err) => {
          console.log("请求失败");
        });
    })
    .catch(() => {
      console.log("取消");
    });
}
//移交门店
function handOver(id, type) {
  if (type == "all") {
    id = id.join(",");
    if (!id)
      return ElMessage({
        message: `请选择门店`,
        type: "warning",
      });
  }
  ElMessageBox.prompt("请填写要移交的账号", "移交门店", {
    confirmButtonText: "确定",
    cancelButtonText: "取消",
  })
    .then(({ value }) => {
      proxy.$http
        .post(`webapi/hotel_mgr?item=set`, { id, utel: value })
        .then(({ data: res }) => {
          if (res.code == 0) {
            ElMessage({
              message: `移交成功！`,
              type: "success",
            });
            dialogVisible.value = false;
            hotelListGet();
          } else {
            ElMessage({
              message: `移交失败！`,
              type: "error",
            });
          }
        })
        .catch((err) => {
          console.log("请求失败");
        });
    })
    .catch(() => {
      console.log("取消移交");
    });
}
//弹窗关闭事件
function dialogClosed() {
  formRef.value.resetFields();
  form.id = undefined;
  form.name = "";
  form.remark = "";
  form.state = 1;
  form.tid = "";
  form.extra_code = "";
  form.country = 0;
  form.prov = undefined;
  form.city = undefined;
  form.area = undefined;
  form.address = "";
  form.username = "";
  form.tel = "";
  form.logo = "";
  form.images = [];
  form.hotel_star = 0;
  form.wash_mode = 0;
}
//图片资源弹窗打开
function iconEditor(id, type) {
  explorerSelect.value = id;
  iconType.value = type;
  nextTick(() => {
    explorerDialogVisible.value = true;
    resourceGet();
  });
}
//图片资源获取
function resourceGet(obj) {
  proxy.$http
    .get("webapi/resource_mgr", {
      params: {
        item: "list",
        name: obj ? obj.name || "" : "",
        pid: obj ? obj.select || explorerSelect.value : explorerSelect.value,
        page: obj ? obj.page || 1 : 1,
      },
    })
    .then(({ data: res }) => {
      fileData.value = res.data.list;
      fileSum.value = res.data.count;
    })
    .catch((err) => {
      console.log("相册资源请求失败");
    });
}
//图片资源确定
function confirm(checkedData) {
  switch (iconType.value) {
    case "radio":
      form.logo = checkedData.url;
      break;
    case "checked":
      console.log(checkedData);
      form.images = [...form.images, ...checkedData.map((item) => item.url)];
      break;
    default:
      break;
  }
  explorerDialogVisible.value = false;
}
//图片资源分类选择
function selected(val) {
  explorerSelect.value = val;
}
//门店类型获取
function hotelTypeGet() {
  let req = {
    all: 1,
  };
  proxy.$http
    .get("webapi/hotel_type_mgr?item=list", {
      params: {
        ...req,
      },
    })
    .then(({ data: res }) => {
      if (res.code == 0) {
        hotelTypeData.value = res.data.list;
      }
    })
    .catch((err) => {
      console.log("请求失败");
    });
}
//门店类型变换
function handleCommand(e) {
  hotelList_req.tid = e;
}
//打电话
function call(tel) {
  const a = document.createElement("a");
  a.href = "tel:" + tel;
  a.click();
}
//复制
function onCopy(copytext) {
  proxy.$copyText(copytext).then(
    function (e) {
      ElMessage({
        message: `【${copytext}】复制成功！`,
        type: "success",
      });
    },
    function (e) {
      ElMessage({
        message: `复制失败！`,
        type: "error",
      });
    }
  );
}
//门店设备列表打开
function deviceOpen(obj) {
  opendrawer("washingMachineList", obj);
}
//门店设备配置打开
function settingOpen(obj) {
  opendrawer("washingMachineSetting", obj);
}
//pms配置弹窗打开事件
function pmsSettingOpen(obj) {
  form2.hotel_id = obj.id;
  pmsTypeGet(obj.id);
  pmsSettingGet(obj.id);
  dialogVisible2.value = true;
}
//pms配置获取
function pmsSettingGet(hotel_id) {
  if (hotel_id === undefined) return;
  proxy.$http
    .post(`webapi/hotel_pms_settings_mgr?item=get`, {
      hotel_id,
    })
    .then(({ data: res }) => {
      let obj = res.data || {};
      form2.type = obj.type || "";
      form2.remark = obj.remark || "";
      form2.state = obj.state !== undefined ? obj.state : 1;
      form2.settings = obj.settings || {};
      formMap[form2.type].forEach((item) => {
        item.itemValue = form2.settings[item.itemKey] || "";
      });
    })
    .catch((err) => {
      console.log("pms配置获取请求失败", err);
    });
}
//门店类型获取
function pmsTypeGet(hotel_id) {
  if (hotel_id === undefined) return;
  proxy.$http
    .get("webapi/hotel_pms_settings_mgr?item=types", {
      params: {
        hotel_id,
      },
    })
    .then(({ data: res }) => {
      if (res.code == 0) {
        pmsTypeData.value = res.data;
      }
    })
    .catch((err) => {
      console.log("门店类型获取请求失败");
    });
}
//pms配置保存
function pmsSettingSet(formEl) {
  formMap[form2.type].forEach((item) => {
    if (item.itemValue) form2.settings[item.itemKey] = item.itemValue;
  });
  formEl.validate((valid) => {
    if (valid) {
      proxy.$http
        .post(`webapi/hotel_pms_settings_mgr?item=set`, {
          ...form2,
        })
        .then(({ data: res }) => {
          if (res.code == 0) {
            ElMessage({
              message: `配置成功！`,
              type: "success",
            });
            dialogVisible2.value = false;
            hotelListGet();
          } else {
            ElMessage({
              message: `配置失败！`,
              type: "error",
            });
          }
        })
        .catch((err) => {
          console.log("请求失败");
        });
    }
  });
}
//pms配置弹窗关闭事件
function dialogClosed2() {
  formMap[form2.type].forEach((item) => {
    item.itemValue = "";
  });
  formRef2.value.resetFields();
  form2.type = "";
  form2.settings = {};
  form2.remark = "";
  form2.state = 1;
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/hotel/hotelList.scss";
</style>